import { Box, Modal } from "@mui/material";
import "./chooseExamType.scss";
import { BrandButton, BrandButtonWhite } from "./form/buttons";

interface Props {
  open: boolean;
  setExamType: (type:number) => void;
  data: any;
}

const ChooseExamType = ({ open, setExamType, data }: Props) => {
  if (!data) return <div></div>;
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="chooseExamType">
        <div className="box-holder">
          <div>
            <p
              className="headerBox"
              dangerouslySetInnerHTML={{ __html: data.data.standardHeadline }}
            />
            <p
              className="content"
              dangerouslySetInnerHTML={{
                __html: data.data.standardDescription,
              }}
            />
            <p className="buttonHolder">
              <BrandButtonWhite onClick={() => setExamType(0)}>CONTINUE</BrandButtonWhite>
            </p>
          </div>
          <div>
            <p
              className="headerBox"
              dangerouslySetInnerHTML={{ __html: data.data.extendedHeadline }}
            />
            <p
              className="content"
              dangerouslySetInnerHTML={{
                __html: data.data.extendedDescription,
              }}
            />
            <p className="buttonHolder">
              <BrandButton onClick={() => setExamType(1)}>CONTINUE</BrandButton>
            </p>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
export default ChooseExamType;
